import React from "react";
import styled from "styled-components";
import { content } from "@glossy";
import { Locale } from "@linkfluence/models/locale";
import Button from "@ui-kit/button";
import { tr } from "@radarly/i18n";

interface IProps {
  onApply: () => void;
  onClear?: () => void;
  onCancel?: () => void;
  locale?: Locale;
  disabled?: boolean;
  validateLabel?: string;
}

const Footer = styled.footer`
  display: flex;
  justify-content: space-between;
  padding: 24px;
  border-top: 1px solid;
  border-color: ${(props) => content(props, "tertiary")};
`;

const UiKitPopoverPanelFooter = ({
  onApply,
  onClear,
  locale,
  disabled,
  onCancel,
  validateLabel,
}: IProps) => (
  <Footer>
    <Button
      text={onCancel ? tr(locale, "FORM::CANCEL") : tr(locale, "FORM::CLEAR")}
      size="m"
      onClick={onCancel ? onCancel : onClear}
      variant="tertiary"
    />
    <Button
      text={validateLabel || tr(locale, "FORM::APPLY")}
      size="m"
      onClick={onApply}
      variant="primary"
      isDisabled={disabled}
    />
  </Footer>
);

export default UiKitPopoverPanelFooter;
